import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ruletaPremiosService, RuletaConfig } from '../../services/ruletaPremios';
import RuletaPremiosModal from './RuletaPremiosModal';

// Feature flag: desactivar ruleta mientras no exista endpoint en API
const RULETA_ENABLED = false;

export default function RuletaPremiosWrapper() {
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState<RuletaConfig | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (!RULETA_ENABLED) return;
    loadConfig();
  }, []);

  useEffect(() => {
    if (!RULETA_ENABLED) return;
    if (config) {
      checkAndShowRuleta();
    }
  }, [config, location.pathname]);

  const loadConfig = async () => {
    try {
      const configData = await ruletaPremiosService.getConfig();
      setConfig(configData);
    } catch (error) {
      console.error('Error loading ruleta config:', error);
    }
  };

  const checkAndShowRuleta = () => {
    // Si la ruleta NO está activa, no renderizar nada
    if (!config || !config.ruleta_activa) {
      return;
    }

    // Obtener la URL actual y normalizarla
    const paginaActual = location.pathname;
    const paginaNormalizada = paginaActual.replace(/\/$/, '') || '/';

    // Verificar si debe aparecer en esta página específica (comparación EXACTA)
    const debeAparecerEnEstaPagina = config.mostrar_en_paginas.some(pagina => {
      const paginaConfigNormalizada = pagina.replace(/\/$/, '') || '/';
      return paginaNormalizada === paginaConfigNormalizada;
    });

    // Si NO debe aparecer en esta página, salir inmediatamente
    if (!debeAparecerEnEstaPagina) {
      return;
    }

    // Verificar si ya se mostró (MISMA CLAVE PARA TODAS LAS PÁGINAS)
    const storageKey = 'ruleta_mostrada';
    const yaMostrada = localStorage.getItem(storageKey);
    
    if (yaMostrada) {
      return;
    }

    // Marcar como ya mostrada (MISMA CLAVE PARA TODAS LAS PÁGINAS)
    localStorage.setItem(storageKey, 'true');

    // Aplicar el modo de aparición configurado
    switch (config.modo_aparicion) {
      case 'inmediato':
        setShowModal(true);
        break;

      case 'delay':
        setTimeout(() => {
          setShowModal(true);
        }, config.delay_segundos * 1000);
        break;

      case 'exit_intent':
        const handleMouseLeave = (e: MouseEvent) => {
          if (e.clientY <= 0) {
            setShowModal(true);
            document.removeEventListener('mouseleave', handleMouseLeave);
          }
        };
        document.addEventListener('mouseleave', handleMouseLeave);
        return () => document.removeEventListener('mouseleave', handleMouseLeave);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  // Si feature flag desactivado o config.enabled === false, no renderizar ruleta
  if (!RULETA_ENABLED || !config || !config.ruleta_activa || !showModal) return null;

  return <RuletaPremiosModal onClose={handleClose} />;
}
